import { form, isSubmitting } from '../state'
import { validateForm } from './validate-form'
import { useSuggestionsManagement } from '../../use-suggestions-management'

/**
 * Öneri düzenleme form verisini gönderir
 * @param {Object} suggestion - Mevcut öneri objesi
 * @param {Function} onSuccess - Başarılı sonuç sonrası çalışacak fonksiyon
 * @param {Function} onError - Hata durumunda çalışacak fonksiyon
 * @returns {Promise<Boolean>} İşlem başarılı mı
 */
export const submitForm = async (suggestion, onSuccess = null, onError = null) => {
  if (!suggestion || !validateForm(null, suggestion.contentType)) return false

  try {
    isSubmitting.value = true

    // Suggestion management composable'dan updateSuggestion metodunu al
    const { updateSuggestion } = useSuggestionsManagement()

    // Gönderim verilerini hazırla
    const suggestionData = {
      suggestion: form.suggestion,
      priority: form.priority,
    }

    // İçerik tipine özel alanları ekle
    if (suggestion.contentType === 'IMAGE') {
      suggestionData.currentImageUrl = form.currentImageUrl
    }

    if (suggestion.contentType === 'VIDEO') {
      suggestionData.currentVideoUrl = form.currentVideoUrl
    }

    if (suggestion.contentType === 'TEXT') {
      suggestionData.currentText = form.currentText
    }

    // Öneriyi güncelle
    const result = await updateSuggestion(suggestion.id, suggestionData)

    // Başarı olayını bildir
    if (result) {
      if (onSuccess && typeof onSuccess === 'function') {
        onSuccess(result)
      }
      return true
    } else {
      // Hata durumu - güncelleme başarısız oldu
      console.error('Update failed: No data returned')
      if (onError && typeof onError === 'function') {
        onError(new Error('Update failed: No data returned'))
      }
      return false
    }
  } catch (error) {
    console.error('Error updating suggestion:', error)
    if (onError && typeof onError === 'function') {
      onError(error)
    }
    return false
  } finally {
    isSubmitting.value = false
  }
}
